import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';

const firebaseRef = firebase.database();

export default async function getAllAgreements(callback) {
	await firebaseRef
		.ref('/kavtek_agreements/' + PROJECT_CODE.projectCode)
		.on('value', (snapshot) => {
			var agreementArr = [];
			var agreementsObj = snapshot.val();

			var agreementsObjKeys =
				agreementsObj && Object?.keys(agreementsObj);

			agreementsObjKeys?.forEach((key) => {
				var agreement = agreementsObj[key];
				agreement['leadsKey'] = key;

				agreementArr.push(agreement);
			});
			callback(agreementArr);
		});
}
